import axios from "../../config/axiosConfig";
import {
  DEBIT_CREDIT_NOTE_BILL_BASE_REPORT_REQUEST,
  DEBIT_CREDIT_NOTE_BILL_BASE_REPORT_SUCCESS,
  DEBIT_CREDIT_NOTE_BILL_BASE_REPORT_FAILURE
} from "../types/debit-credit-note-bill-base-report-types";

export const getDebitCreditNoteBillBaseReport = (params, registerType) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_CREDIT_NOTE_BILL_BASE_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
      console.log('params',params);
      
      const defaultParams2 = {
        filterType: params?.filterType || '',
        fromDate: params?.fromDate || '', 
        toDate: params?.toDate || '', 
        ...params
      };

      const requestParams = { ...defaultParams, ...defaultParams2 };

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/${registerType === 'credit' ? 'credit-note-bill-base' : 'debit-note-bill-base'}/getReport?${queryString}`;
      console.log('Complete API Request URL: ', fullUrl);

      axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        if (response.data) {
          dispatch({ type: DEBIT_CREDIT_NOTE_BILL_BASE_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Register Report:", error);
        dispatch({ type: DEBIT_CREDIT_NOTE_BILL_BASE_REPORT_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error("Error fetching Sales Register Report:", error);
      dispatch({ type: DEBIT_CREDIT_NOTE_BILL_BASE_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearDebitCreditNoteBillBaseReport = () => {
  return async (dispatch) => {
    dispatch({ type: DEBIT_CREDIT_NOTE_BILL_BASE_REPORT_SUCCESS, payload: {} });
  }
}
